import React from 'react';

const Turkey = (props) => (
<img src="https://flagsapi.com/TR/flat/64.png"/>
);

export default Turkey;



